import React from 'react';
import { TileIds, TileRules } from '../../../../util/tileEnums';
import { UniversalModalValue } from '../../../components/InsuranceHelpModal/modalValues';
import { InsurerCodes } from '../../../../../../../constants/insurance';
import { aetnaInsightTiles } from './aetna';
import { cignaInsightTiles } from './cigna';
import { unitedInsightTiles } from './united';
import { bcbsCaInsightTiles, bcbsInsightTiles, bcbsTxInsightTiles } from './bcbs';
import { safeGet } from '../../../../../../../core/util/object';

const universalInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_ANNUAL_WELLNESS,
    header: 'Checkup? Check.',
    description: () => `Free annual wellness exam`,
    rules: [TileRules.IS_NOT_CHILD],
    modalValue: UniversalModalValue.ANNUAL_WELLNESS,
    sortOrder: {
      [InsurerCodes.AETNA]: 3,
      [InsurerCodes.BLUE_SHIELD_CA]: 3,
      [InsurerCodes.BLUE_SHIELD_TX]: 3,
      [InsurerCodes.CIGNA]: 2,
      [InsurerCodes.UNITED_HEALTH_CARE]: 2,
    },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_PAP,
    header: "Women's Wellness",
    description: () => `Free Pap smear every three years`,
    rules: [TileRules.IS_WOMAN_AGE_18_65],
    modalValue: UniversalModalValue.PAP,
    sortOrder: {
      [InsurerCodes.AETNA]: 5,
      [InsurerCodes.BLUE_SHIELD_CA]: 5,
      [InsurerCodes.BLUE_SHIELD_TX]: 5,
      [InsurerCodes.CIGNA]: 4,
      [InsurerCodes.UNITED_HEALTH_CARE]: 5,
    },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_MAMMOGRAM,
    header: 'Breast Cancer Screening',
    description: () => `Free mammogram every one to two years`,
    rules: [TileRules.IS_WOMAN_OVER_39],
    modalValue: UniversalModalValue.MAMMOGRAM,
    sortOrder: {
      [InsurerCodes.AETNA]: 10,
      [InsurerCodes.BLUE_SHIELD_CA]: 10,
      [InsurerCodes.BLUE_SHIELD_TX]: 9,
      [InsurerCodes.CIGNA]: 7,
      [InsurerCodes.UNITED_HEALTH_CARE]: 6,
    },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_OSTEOPOROSIS,
    header: 'Know Your Bones',
    description: () => `Free osteoporosis screening every one to two years`,
    rules: [TileRules.IS_WOMAN_OVER_65],
    modalValue: UniversalModalValue.OSTEOPOROSIS,
    sortOrder: {
      [InsurerCodes.AETNA]: 13,
      [InsurerCodes.BLUE_SHIELD_CA]: 11,
      [InsurerCodes.BLUE_SHIELD_TX]: 10,
      [InsurerCodes.CIGNA]: 14,
      [InsurerCodes.UNITED_HEALTH_CARE]: 9,
    },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_COLON_CANCER_SCREENING,
    header: 'Detect Colon Cancer',
    description: () => `Free annual colon cancer screening`,
    rules: [TileRules.IS_AGE_50_75],
    modalValue: UniversalModalValue.COLON_CANCER_SCREENING,
    sortOrder: {
      [InsurerCodes.AETNA]: 14,
      [InsurerCodes.BLUE_SHIELD_CA]: 13,
      [InsurerCodes.BLUE_SHIELD_TX]: 13,
      [InsurerCodes.CIGNA]: 15,
      [InsurerCodes.UNITED_HEALTH_CARE]: 11,
    },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_BREAST_PUMP,
    header: 'For New Moms',
    description: () => `Free breast pump`,
    rules: [TileRules.IS_WOMAN_AGE_25_42],
    modalValue: UniversalModalValue.BREAST_PUMP,
    sortOrder: {
      [InsurerCodes.AETNA]: 7,
      [InsurerCodes.BLUE_SHIELD_CA]: 8,
      [InsurerCodes.BLUE_SHIELD_TX]: 7,
      [InsurerCodes.CIGNA]: 10,
      [InsurerCodes.UNITED_HEALTH_CARE]: 8,
    },
  },
];

const insightDescriptions = [
  ...aetnaInsightTiles,
  ...cignaInsightTiles,
  ...unitedInsightTiles,
  ...bcbsInsightTiles,
  ...bcbsCaInsightTiles,
  ...bcbsTxInsightTiles,
  ...universalInsightTiles,
];

const sortFn = (insurerCode: any) => (a: any, b: any) => {
  const x = safeGet(a, -1)(`sortOrder.${insurerCode}`);

  const y = safeGet(b, -1)(`sortOrder.${insurerCode}`);
  return x - y;
};

export { insightDescriptions, sortFn, universalInsightTiles };
